import { IJSendSuccessResponse } from "typings";
import { fetcher } from "utils";

type PostSMSAuthVerifyRequest = (payload: {
  phone_number: string;
  verification_code: string;
}) => Promise<IJSendSuccessResponse<{}>>;

export const postSMSAuthVerify: PostSMSAuthVerifyRequest = payload => fetcher.post("/api/v1/sms_auth/verify", payload);
